// components/shared/sites/SitesList.tsx
import { Site } from "../../../types/features/Site";
import TableList, { SelectAction } from "../../ui/TableList";
import SiteRow from "./SiteRow";

interface SitesListProps {
  sites: Site[];
  onAction: (site: Site) => void;
  onSelectSites?: (selectedSites: Site[]) => void;
  selectable?: boolean;
  selectActions?: SelectAction[];
  loading?: boolean;
  emptyMessage?: string;
}

export default function SitesList({
  sites,
  onAction,
  onSelectSites,
  selectable = false,
  selectActions,
  loading = false,
  emptyMessage = "Aucun site trouvé",
}: SitesListProps) {
  const columns = [
    { header: "Site", className: "w-2/5" },
    { header: "Domaine", className: "w-1/5" },
    { header: "Langue", className: "hidden sm:table-cell w-1/6" },
    { header: "Statut", className: "hidden md:table-cell w-1/6" },
    { header: "Créé le", className: "hidden lg:table-cell w-1/6" },
  ];

  if (loading) {
    return (
      <div className="flex justify-center items-center py-12">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div>
      </div>
    );
  }

  return (
    <TableList
      items={sites}
      columns={columns}
      getId={(site) => site.id}
      onAction={onAction}
      onSelectItems={onSelectSites}
      selectable={selectable}
      emptyMessage={emptyMessage}
      actionColumn={true}
      selectActions={selectActions}
      renderRow={(site, isSelected, onSelect) => (
        <SiteRow
          key={site.id}
          site={site}
          onAction={onAction}
          onSelect={onSelect}
          isSelected={isSelected}
          selectable={selectable}
        />
      )}
    />
  );
}